// extracted by mini-css-extract-plugin
module.exports = {"title-tab":"style_title-tab__1ETVf","title-tab-large":"style_title-tab-large__3CQFG"};